import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { RouteLocationRaw } from 'vue-router'
import type { IconValue } from 'vuetify/lib/composables/icons.mjs'
import type { VSnackbar } from 'vuetify/components'

/**
 * A queued snackbar message.
 *
 * `icon` and `to` were added for ADA-4345: the overpayment nudge is a message the debtor is meant
 * to act on, so it carries a leading icon and links into the view. Both are optional — a plain
 * string or a text-only object behaves exactly as before.
 */
export type SnackbarMessage =
  | string
  | (Pick<VSnackbar['$props'], 'color' | 'text' | 'timeout'> & {
      icon?: IconValue
      to?: RouteLocationRaw
    })

export const useMessagesStore = defineStore('messages', () => {
  const queue = ref<SnackbarMessage[]>([])
  function addMessage(message: SnackbarMessage) {
    queue.value.push(message)
  }

  return { queue, addMessage }
})
